import React from 'react';
import Header from './Header';
import HeaderSecond from './HeaderSecond';
import Categories from './Categories';
import Search from './Search';
import SearchResult from './SearchResult';
import Selected from './Selected';
import Form from './Form';
import Confirm from './Confirm';

export default class App extends React.Component {
	
	content = {
		'localhost' : {
			title : 'Dev mode on localhost',
			logo : 'logo_kunc',
			url : 'https://www.kuntsevoplaza.ru/ru'
		},
		'brands.kashirskaya-plaza.ru' : {
			title : 'Каширская плаза',
			logo : 'logo_kash',
			url : 'https://www.kashirskayaplaza.com/ru'
		},
		'brands.kuntsevoplaza.ru' : {
			title : 'Кунцево плаза',
			logo : 'logo_kunc',
			url : 'https://www.kuntsevoplaza.ru/ru'
		},
		'brands.vr.kapitoliy.ru' : {
			title : 'Капитолий Вернадского',
			logo : 'logo_kap',
			url : 'https://www.kapitoliy.ru/ru/malls/kapitoliy-vernadskogo'
		},
		'brands.lg.kapitoliy.ru' : {
			title : 'Капитолий Ленинградский',
			logo : 'logo_kap',
			url : 'https://www.kapitoliy.ru/ru/malls/kapitoliy-leningradskiy'
		},
		'brands.sv.kapitoliy.ru' :  {
			title : 'Капитолий Севастопольский',
			logo : 'logo_kap',
			url : 'https://www.kapitoliy.ru/ru/malls/kapitoliy-sevastopolsky'
		},
		'brands.spb.kapitoliy.ru' : {
			title : 'Капитолий Аутлет',
			logo : 'logo_kap',
			url : 'https://www.kapitoliy.ru/ru/malls/kapitoliy-outlet'
		},
		'brands.mr.kapitoliy.ru' :  {
			title : 'Капитолий Марьина Роща',
			logo : 'logo_kap',
			url : 'https://www.kapitoliy.ru/ru/malls/kapitoliy-maryina-roscha'
		},
		'brands.sp.kapitoliy.ru' :  {
			title : 'Капитолий Сергиев Посад',
			logo : 'logo_kap',
			url : 'https://www.kapitoliy.ru/ru/malls/kapitoliy-sergiev-posad'
		},
		'brands.bel.kapitoliy.ru' : {
			title : 'Капитолий Беляево',
			logo : 'logo_kap',
			url : 'https://www.kapitoliy.ru/ru/malls/kapitoliy-belyaevo'
		},
		'brands.oz.kapitoliy.ru' : {
			title : 'Капитолий Орехово-Зуево',
			logo : 'logo_kap',
			url : 'https://www.kapitoliy.ru/ru/malls/kapitoliy-orekhovo-zuevo'
		},
        'brands.pd.kapitoliy.ru' : {
			title : 'Капитолий Подольск',
			logo : 'logo_kap',
			url : 'https://www.kapitoliy.ru/ru/malls/kapitoliy-podolsk'
		}
	}

    constructor(props) {
		super(props);
		this.state = {
			brands : [],
			cats : [],
			cat_id : null,
			query : '',
			selected : [],
			step : 'select',
			form : {},
			queryInput : null
		};
		this.selectCategory = this.selectCategory.bind(this);
		this.setQuery = this.setQuery.bind(this);
		this.resetSearch = this.resetSearch.bind(this);
		this.changeSelect = this.changeSelect.bind(this);
		this.getChecked = this.getChecked.bind(this);
		this.changeStep = this.changeStep.bind(this);
		this.setForm = this.setForm.bind(this);
		let hostname = window.location.hostname;
		this.title = document.title = this.content[hostname].title;
		this.logo = this.content[hostname].logo;
		this.url = this.content[hostname].url;
    }
	
	selectCategory(id) {
		this.setState({
			cat_id : id
		});
	}

	componentDidMount() {
		fetch(`/brandquiz/data`)
		.then((response) => response.json())
		.then((responseJson) => {
			this.setState({ brands : responseJson.brands, cats : responseJson.cats})
		})
		.catch((error) => {
			console.error(error);
		});
	}
	
	getCategoryName(id) {
		let cat = this.state.cats.find(c => c.id==id);
		return cat?cat.title:null;
	}
	
	getCountInCategory(id) {
		let count=0;
		this.state.selected.map(s => {
			if (s.cats.indexOf(id)!==-1) count++;
		});
		return count;
	}
	
	getSelectedTotal() {
		return this.state.selected.length;
	}
	
	setQuery(value,queryInput) {
		this.setState({
			query : value,
			queryInput : queryInput
		});
	}

	resetSearch() {
		this.setState({
			query : '',
			cat_id : null
		},() => {
			if (this.state.queryInput) this.state.queryInput.current.focus();
		});
	}
	
	changeSelect(e, item) {
		let checked = e.target.checked;
		if (e.target.tagName == 'A') {
			checked = false;
			e.preventDefault();
		}
		let index = this.state.selected.findIndex(el => el.id==item.id);
		let selected = [...this.state.selected];
		if (checked && index === -1) 
			selected.push(item);
		else if (!checked && index>=0)
			selected.splice(index, 1);
		let state = {
			selected : selected
		};
		if (selected.length==0 && this.state.step=='selected')
			state.step = 'select';
		this.setState(state);
	}

	getChecked(id) {
		let index = this.state.selected.findIndex(el => el.id==id);
		if (index!== -1) return true;
		return false;
	}
	
	changeStep(s,e){
		if (e) e.preventDefault();
		if (s == 'selected' && this.state.selected.length==0) return;
		this.setState({
			step : s 
		});
	}
	
	setForm(form) {
		this.setState({
			form : form
		});
	}

	render() {
		return (
			<div>
				<Header 
					step={this.state.step} 
					selectedTotal={this.getSelectedTotal()}
					showTotal={!this.state.cat_id&&!this.state.query}
					changeStep={this.changeStep}
					form={this.state.form}
					title={this.title}
					logo={this.logo}
					url={this.url}
				/>				
				{this.state.step == 'select' &&
					<HeaderSecond 
						category={this.getCategoryName(this.state.cat_id)}
						countInCategory={this.getCountInCategory(this.state.cat_id)}
						selectedTotal={this.getSelectedTotal()}
						showTotal={this.state.cat_id||this.state.query}
						resetSearch={this.resetSearch}
						changeStep={this.changeStep}
					/>
				}
				{this.state.step == 'select' &&
					<Search setQuery={this.setQuery} query={this.state.query}/>
				}
				{this.state.step == 'select' && !this.state.cat_id && !this.state.query &&
					<Categories 
						cats={this.state.cats} 
						selectCategory={this.selectCategory}
					/>
				}
				{this.state.step == 'select' && (this.state.cat_id || this.state.query) &&
					<SearchResult 
						resetSearch={this.resetSearch} 
						brands={this.state.brands} 
						cat_id={this.state.cat_id} 
						query={this.state.query}
						changeSelect={this.changeSelect}
						getChecked={this.getChecked}
						changeStep={this.changeStep}
					/>
				}
				{this.state.step == 'selected' && this.state.selected.length>0 &&
					<Selected
						cats={this.state.cats}
						brands={this.state.brands}
						selected={this.state.selected}
						changeStep={this.changeStep}
						changeSelect={this.changeSelect}
					/>
				}
				{this.state.step == 'form' && this.state.selected.length>0 &&
					<Form
						selected={this.state.selected}
						changeStep={this.changeStep}
						setForm={this.setForm}
					/>
				}
				{this.state.step == 'confirm' &&
					<Confirm selected={this.state.selected} user={this.state.form} changeStep={this.changeStep}/>
				}
			</div>
		);
	}

}